import { HTMLProps } from "react";
import { cn } from "@/utils/helpers";
import styles from "./Svg.module.css";

export interface SvgProps extends HTMLProps<HTMLOrSVGElement> {
	color?: "primary" | "secondary" | "tertiary";
};

export default function Svg({
	width,
	height,
	color,
	title,
	children,
	className,
} : SvgProps) {

	return (
		<svg
			width={width}
			height={height}
			viewBox={width && height ? `0 0 ${width} ${height}` : undefined}
			xmlns="http://www.w3.org/2000/svg"
			className={cn(
				styles.Svg,
				color ? styles[`Svg_${color}`] : null,
				className
			)}
			
		>
			{title ? <title>{title}</title> : null}
			{children}
		</svg>
	)
};
